<template>
  <AdminCrudPage
    collection-name="gallery"
    title="Gallery"
    singular-title="Photo"
    :fields="fields"
    :columns="columns"
    :seed-data="seedData"
  />
</template>

<script>
import AdminCrudPage from './AdminCrudPage.vue'
import gallery1 from '../../assets/images/gallery-1.jpg'
import gallery3 from '../../assets/images/gallery-3.jpg'
import madinaDuskGate from '../../assets/images/madina/madina-dusk-gate.jpg'
import madinaNightCourtyard from '../../assets/images/madina/madina-night-courtyard.png'
import madinaAerialDusk from '../../assets/images/madina/madina-aerial-dusk.jpg'
import madinaDomeDusk from '../../assets/images/madina/madina-dome-dusk.jpg'

export default {
  name: 'AdminGallery',
  components: { AdminCrudPage },
  data() {
    return {
      columns: [
        { key: 'title', label: 'Title' },
        { key: 'category', label: 'Category' }
      ],
      fields: [
        { key: 'title', label: 'Title', type: 'text', required: true },
        { key: 'category', label: 'Category (e.g. Makkah, Madina)', type: 'text' },
        { key: 'description', label: 'Description', type: 'textarea' },
        { key: 'image', label: 'Image', type: 'image' }
      ],
      seedData: [
        {
          title: 'The Sacred Kaaba at Masjid al-Haram',
          category: 'Makkah',
          description: 'Pilgrims performing Tawaf around the Kaaba in the Grand Mosque.',
          image: gallery1
        },
        {
          title: 'Masjid an-Nabawi at Dusk',
          category: 'Madina',
          description: 'Pilgrims gathered at the gates of the Prophet\'s Mosque as evening lights come on.',
          image: madinaDuskGate
        },
        {
          title: 'Luxury Kaaba View Suite',
          category: 'Hospitality',
          description: 'Premium accommodations with panoramic view of the Holy Kaaba.',
          image: gallery3
        },
        {
          title: 'Masjid an-Nabawi Courtyard at Night',
          category: 'Madina',
          description: 'Pilgrims praying in the illuminated courtyard beneath the Green Dome.',
          image: madinaNightCourtyard
        },
        {
          title: 'Aerial View of the Prophet\'s Mosque',
          category: 'Madina',
          description: 'A sweeping dusk view of Masjid an-Nabawi and the surrounding city.',
          image: madinaAerialDusk
        },
        {
          title: 'Masjid an-Nabawi at Golden Hour',
          category: 'Madina',
          description: 'The Prophet\'s Mosque bathed in warm evening light, a moment of serenity.',
          image: madinaDomeDusk
        }
      ]
    }
  }
}
</script>
